<section id="about" >
    <div class="container">
    <header class="section-header">
      <h3 class="section-title">Cloud Based Solutions</h3>
    </header>
    <p class="description">We have strong experience in IaaS, PaaS, and SaaS, all three main models of cloud computing services.</p>
 
  </div>
  </section>